module.exports = __webpack_public_path__ + "static/media/vanity square sink.1725dc77.jpg";